module.exports = "<router-outlet></router-outlet>\n\n"


//////////////////
// WEBPACK FOOTER
// /Users/meghneel/work/shree_translogic_dashboard/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main